export default "__VITE_ASSET__DiKos3w8__"